<!-- 

	Was macht diese Componente?
	Wofür ist die Compoente da?
	
	Welche $props gibt es?
	
	Beispiel Code:
		<Dummy></Dummy>
	
	2019-06-08	init

-->

<template>
	<div class="CvSelect" :class="elmClasses">
		
		<!-- einfaches select: invalid -->
		<template v-if="!isMultiSelect && hasInvalidValues">
			<div class="vSpace vSpace--default font font--sizeSmall" v-if="model && value">
				Der Datensatz enthält folgenden invaliden Wert:
			</div>
			<BaseText 
				class="CvSelect__invalidValue blend blend--multiply"
				:value="value"
				:hasClearButton="true"
				:disabled="true"
				@input="removeInvalidValue( value )"
				v-if="model && value"
			></BaseText>			
			<div class="vSpace vSpace--default font font--sizeSmall" v-if="value">
				Bitte einen validen Wert auswählen:
			</div>
		
			<BaseSelect
				:value="''"
				:label="'Bitte wählen ...'"
				:options="optionsForSelect"
				:multiple="isMultiSelect"
				@input="valueChanged"
			></BaseSelect>
		</template>
		<!-- einfaches select: valid -->
		<template v-if="!isMultiSelect && !hasInvalidValues">
			<BaseSelect
				:value="value"
				:label="'Bitte wählen ...'"
				:options="optionsForSelect"
				:multiple="isMultiSelect"
				@input="valueChanged"
			></BaseSelect>
		</template>
		
		<!-- multi select: invalid -->
		<template v-if="isMultiSelect && hasInvalidValues">
			<div class="vSpace vSpace--default font font--sizeSmall">
				Der Datensatz enthält folgende invalide Werte:
			</div>
			<BaseText 
				class="CvSelect__invalidValue blend blend--multiply"
				:value="invalidValue"
				:hasClearButton="true"
				:disabled="true" 
				v-for="(invalidValue, index) in invalidValues" :key="index"
				@input="removeInvalidValue( invalidValue )"
			></BaseText>
			<div class="vSpace vSpace--default font font--sizeSmall">
				Bitte mindestens einen validen Wert auswählen:
			</div>
			
			<BaseSelect
				:value="valueForSelect"
				:label="'Bitte wählen ...'"
				:options="optionsForSelect"
				:multiple="isMultiSelect"
				@input="valueChanged"
			></BaseSelect>
		</template>
		<!-- multi select: valid -->
		<template v-if="isMultiSelect && !hasInvalidValues">
			<BaseSelect
				:value="value.split(', ')"
				:label="'Bitte wählen ...'"
				:options="optionsForSelect"
				:multiple="isMultiSelect"
				@input="valueChanged"
			></BaseSelect>
		</template>
		
		<div class="CvSelect__debug vSpace vSpace--default" v-if="debug">
			<pre name="rule">{{rule}}</pre>
			<pre name="isMultiSelect">{{isMultiSelect}}</pre>
			<pre name="value">{{value}}</pre>
			<pre name="model">{{model}}</pre>
			<pre name="invalidValues" v-if="isMultiSelect">{{invalidValues}}</pre>
			<pre name="hasInvalidValues">{{hasInvalidValues}}</pre>
		</div>
		<!--
		-->
	</div>
</template>

<script>
	// @ is an alias to /src
	//import { EventBus } from '@/event-bus.js'
	//import BaseSelectOld from '@/components/MhForm/BaseSelect.vue'
	import BaseSelect from '@/components/MhForm/v1/BaseSelect.vue'
	import BaseText from '@/components/MhForm/v1/BaseText.vue'
	
	// v3 rules
	import klassifikation_v3 from '@/validatorConfig/thesaurus-v3/klassifikation';
	import datierungen_v3 from '@/validatorConfig/thesaurus-v3/datierungen';
	import material_v3 from '@/validatorConfig/thesaurus-v3/material';
	import vorgangsart_v3 from '@/validatorConfig/thesaurus-v3/vorgangsart';
	import kategorie_v3 from '@/validatorConfig/thesaurus-v3/kategorie'
	import probenarten_v3 from '@/validatorConfig/thesaurus-v3/probenarten';
	import formPlanum_v3 from '@/validatorConfig/thesaurus-v3/form_planum';
	import formProfil_v3 from '@/validatorConfig/thesaurus-v3/form_profil';

	// v2 rules
	/*
	import datierungen_v2 from '@/validatorConfig/thesaurus-v2/datierungen';
	import kategorie_v2 from '@/validatorConfig/thesaurus-v2/kategorie'
	import klassifikation_v2 from '@/validatorConfig/thesaurus-v2/klassifikation';
	import material_v2 from '@/validatorConfig/thesaurus-v2/material';
	import probenarten_v2 from '@/validatorConfig/thesaurus-v2/probenarten';
	import vorgangsart_v2 from '@/validatorConfig/thesaurus-v2/vorgangsart';
	*/
	
	// multiselect thes
	//import warenart_v2 from '@/validatorConfig/thesaurus-v2/warenart';
	import warenart_v3 from '@/validatorConfig/thesaurus-v3/warenart';
	//import gefaesspartie_v2 from '@/validatorConfig/thesaurus-v2/gefaesspartie'; // PartiThes_v2
	import gefaesspartie_v3 from '@/validatorConfig/thesaurus-v3/gefaesspartie'; // PartiThes

	export default {
		name: 'CvSelect',
		components: {
			//BaseSelectOld,
			BaseSelect,
			BaseText,
		},
		mixins: [],
		props: {
			rule  : [String, Boolean],
			value : [String, Number, Boolean],			
		},
		data() {
			return {
				debug : false,
				model : undefined,
			}
		},
		watch: {},
		computed: {
			app(){
				return this.$root.$children[0]
			},
			elmClasses(){
				let classes = []
				
				return classes
			},
			isMultiSelect(){ // multiselect anhand der rule
				const multiselectRules = [
					'PartiThes_v2',
					'warenartThes_v2',
					'warenartThes',
					'PartiThes',
				]
				
				return multiselectRules.includes( this.rule )
			},
			valueForSelect(){ // definiert die selected options
				let value = this.value
				
				// split value into array for multi select
				if( this.isMultiSelect ) value = value.split(", ")
				
				/*
				console.group('valueForSelect()')
				console.log('isMultiSelect:', this.isMultiSelect)
				console.log('props value:', this.value)
				console.log('value:', value)
				console.groupEnd()
				*/
				
				return value
			},
			// in einem multi select können eventuell vom benutzer invalide values gesetzt worden sein,
			// diese werden hier rausgefiltert und zurückgegeben 
			invalidValues(){ 
				const doLog = false
				let invalidValues = []
				
				if( doLog ){
					console.group('invalidValues()')
					console.log('   isMultiSelect:', this.isMultiSelect)
					console.log('  valueForSelect:', this.valueForSelect)
					console.log('optionsForSelect:', this.optionsForSelect)
				}
				
				if( this._.isArray( this.valueForSelect ) ){
					invalidValues = this.valueForSelect.filter((item, i) => {
						return !this.optionsForSelect.includes( item ) && item
					})
				}
				
				if( doLog ){
					console.log('   invalidValues:', invalidValues)
					console.groupEnd()
				}
				
				return invalidValues
			},
			// aus welches options das select bestehen soll
			// ergibt sich aus den thesauri der jeweiligen rule
			optionsForSelect(){
				let options = []
				let returnOptions = []
				
				switch( this.rule ) {
					case 'classificationThes':
						options = klassifikation_v3
						break;
					case 'formPlanumThes':
						options = formPlanum_v3
						break;
					case 'DateThes':
						options = datierungen_v3
						break;
					case 'MaterialThes':
						options = material_v3
						break;
					case 'VorgangsThes':
						options = vorgangsart_v3
						break;
					case 'CategoryThes':
						options = kategorie_v3
						break;
					case 'ProbenThes':
						options = probenarten_v3
						break;
					case 'formProfilThes':
						options = formProfil_v3
						break;
					/*
					case 'PartiThes_v2': // multiselect
						options = gefaesspartie_v2
						break;
					case 'warenartThes_v2': // multiselect
						options = warenart_v2
						break;
					case 'classificationThes_v2':
						options = klassifikation_v2
						break;
					case 'DateThes_v2':
						options = datierungen_v2
						break;
					case 'MaterialThes_v2':
						options = material_v2
						break;
					case 'VorgangsThes_v2':
						options = vorgangsart_v2
						break;
					case 'CategoryThes_v2':
						options = kategorie_v2
						break;
					case 'ProbenThes_v2':
						options = probenarten_v2
						break;
					*/						
					case 'PartiThes': // multiselect
						options = gefaesspartie_v3
						break;
					case 'warenartThes': // multiselect
						options = warenart_v3
						break;
				}
				
				returnOptions = this._.clone( options )
				
				// wenn es die value nicht in dem array gibt (weil sie invalid ist)
				// wird sie hier hinzugefügt
				if( !returnOptions.includes( this.value) ){
					//returnOptions.unshift( this.value + ' (ungültig)' )
					//returnOptions.unshift( this.value )
				}
				
				return returnOptions
			},
			hasInvalidValues(){ // boolean
				const doLog            = false
				const isMultiSelect    = this.isMultiSelect
				const optionsForSelect = this.optionsForSelect
				const invalidValues    = this.invalidValues
				let isValid            = false
				let value              = this.value
				
				//console.clear()
				
				if( !isMultiSelect ){
					isValid = optionsForSelect.includes( value )
				}else{
					isValid = invalidValues.length === 0
				}
				
				if( doLog ){
					console.group('hasInvalidValues()')
					console.log('isMultiSelect:', isMultiSelect)
					console.log('optionsForSelect:', optionsForSelect)
					console.log('value:', value)
					console.log('isValid:', isValid)
					console.groupEnd()
				}
				
				return !isValid
			},
		},
		methods: {
			removeInvalidValue( removedValue, doLog = false ){
				const newModel = [] 
				this.model.split(', ').forEach((item)=>{
					console.log('item:', item)
					if( item !== removedValue ) newModel.push( item )
				})
				
				this.model = newModel.join(', ')
				
				if( doLog ){
					console.group('removeInvalidValue()')
					console.log('removedValue:', removedValue)
					console.log('valueForSelect:', this.valueForSelect)
					console.log('model:', this.model)
					console.groupEnd()
				}
				
				this.$emit('input', this.model)
			},
			valueChanged( newValue, doLog = false ){
				if( this._.isArray(newValue) ){ // handles multi selects
					this.model = this.invalidValues.concat( newValue ).join(', ')
				}
				else{
					this.model = newValue					
				}

				if( doLog ){	
					console.group('valueChanged()')
					console.log('newValue:', newValue)
					console.log('model:', this.model)
					console.groupEnd()
				}
				
				this.$emit('input', this.model)
			},
		},
		created() {},
		mounted() {
			this.model = this.value
		},
		destroyed () {},
	}
</script>

<style lang="less">
	@import "../less/vars.less";
	@import (reference) "../less/mixins.less";
	@import (reference) "../less/atoms.less";
	
	.CvSelect {
		//outline: 1px solid fade( blue, 20 );
		position: relative;
		
		&__invalidValue {			
			margin-bottom: 0.5em;
		}
	}
	.CvSelect__debug {
		font-size: 12px;
		line-height: 1.2em;
	}
	
	@media @mediaQueries[xs] {}
	@media @mediaQueries[sm] {}
	@media @mediaQueries[md] {}
	@media @mediaQueries[dt] {}
	@media @mediaQueries[lg] {}
	@media @mediaQueries[xl] {}
</style>
